import React from "react";
import { NewLine } from "ui-builder";

export function NewLineBadgeLayout(props: {
  children: React.ReactNode
}) {
  return (
    <>
      <NewLine />
      {props.children}
    </>
  );
}
